import React from "react";
import MediaSquareTag from "../../../shared/MediaSquareTag";
import PlaylistSquareTag from "../../../shared/PlaylistSquareTag";
import AlbumSquareTag from "../../../shared/Album/AlbumSquareTag";
import UserSquareTag from "../../../shared/UserSquareTag";

export default ({ item }) => {
  switch (item.type) {
    case "User":
      return <UserSquareTag user={item} />;
    case "SoundTrack":
      return <MediaSquareTag medium={item} />;
    case "Video":
      return <MediaSquareTag medium={item} />;
    case "Playlist":
      return <PlaylistSquareTag playlist={item} />;
    case "Album":
      return <AlbumSquareTag album={item} />;
    default:
      return null;
  }
};
